import { useEffect } from 'react';
import { isEmpty } from 'lodash-es';
import { BooleanParam, useQueryParams } from 'use-query-params';

import useIsTierVerificationEnabled from '../../../../../common/hooks/useIsTierVerificationEnabled';
import { OpenRequestModalCallbackProps } from '../constants';
import {
  SubscriptionAssistanceRequestType,
  SubscriptionPlansOption,
} from '../types';

type Props = {
  openAssistanceRequestModal: (options: OpenRequestModalCallbackProps) => void;
  subscriptionPlanOptions?: SubscriptionPlansOption[];
  enabled?: boolean;
};

export const useOpenAssistanceRequestModalByQuery = ({
  openAssistanceRequestModal,
  subscriptionPlanOptions,
  enabled = true,
}: Props) => {
  const isTierVerificationEnabled = useIsTierVerificationEnabled();
  const [
    {
      showCompanyVerificationContactUs,
      showSubscriptionRenewalContactUs,
      showSubscriptionUpgradeContactUs,
    },
    setQueryParam,
  ] = useQueryParams({
    showSubscriptionRenewalContactUs: BooleanParam,
    showCompanyVerificationContactUs: BooleanParam,
    showSubscriptionUpgradeContactUs: BooleanParam,
  });
  useEffect(() => {
    if (!enabled) return;
    if (showSubscriptionRenewalContactUs && !isEmpty(subscriptionPlanOptions)) {
      openAssistanceRequestModal({
        subscriptionAssistanceRequestType:
          SubscriptionAssistanceRequestType.SUBSCRIPTION_PLAN_RENEWAL,
      });
      setQueryParam({
        showSubscriptionRenewalContactUs: undefined,
      });
    } else if (
      isTierVerificationEnabled &&
      showCompanyVerificationContactUs &&
      !isEmpty(subscriptionPlanOptions)
    ) {
      openAssistanceRequestModal({
        subscriptionAssistanceRequestType:
          SubscriptionAssistanceRequestType.COMPANY_VERIFICATION,
      });
      setQueryParam({
        showCompanyVerificationContactUs: undefined,
      });
    } else if (
      showSubscriptionUpgradeContactUs &&
      !isEmpty(subscriptionPlanOptions)
    ) {
      openAssistanceRequestModal({
        subscriptionAssistanceRequestType:
          SubscriptionAssistanceRequestType.SUBSCRIPTION_PLAN_UPGRADE,
      });
      setQueryParam({
        showSubscriptionUpgradeContactUs: undefined,
      });
    }
  }, [
    enabled,
    isTierVerificationEnabled,
    openAssistanceRequestModal,
    setQueryParam,
    showCompanyVerificationContactUs,
    showSubscriptionRenewalContactUs,
    showSubscriptionUpgradeContactUs,
    subscriptionPlanOptions,
  ]);
};
